import Layout from "components/layout";
import GeneralPerformanceGraph from "components/pages/performance/graphs/general_performance";
import LastQuestionnairesGraph from "components/pages/performance/graphs/last_questionnaires";
import SubjectsGraph from "components/pages/performance/graphs/subjects";
import ResolutionTimeGraph from "components/pages/performance/graphs/resolution_time";
import Link from "next/link";

import { track } from "utils/tracker";
import { resetScroll } from "utils/browser";

import { useUser } from "hooks/user";
import { useMounted } from "hooks/react";

export default function Performance(): JSX.Element {
  const { user } = useUser();
  const mounted = useMounted(handleMount);

  function handleMount() {
    resetScroll();
    track("Visited performance page");
  }

  return (
    <Layout
      title="Gráficos de performance"
      description="Acompanhe seu desempenho no decorrer dos estudos para o ENEM e vestibulares com nossos gráficos de performance e tenha controle sobre o seu destino!"
      canonical="/desempenho"
    >
      <main className="pt-[1px] px-0 md:pt-5 md:px-5">
        <div className="container">
          {mounted && !user && (
            <p className="m-5">
              <Link href="/cadastro">
                <a>Crie uma conta</a>
              </Link>{" "}
              agora para acompanhar seu desempenho com os gráficos de
              performance.
              <br />
              <b>É de graça!</b>
            </p>
          )}

          <div className="flex flex-col md:flex-row md:items-stretch">
            <div className="mb-5 md:mb-0 md:mr-8 md:w-3/5">
              <GeneralPerformanceGraph />
            </div>

            <div className="flex-shrink-0 md:w-2/5 md:h-full">
              <LastQuestionnairesGraph />
            </div>
          </div>

          <div className="mt-8">
            <ResolutionTimeGraph />
          </div>

          <div className="mt-8">
            <SubjectsGraph />
          </div>
        </div>
      </main>
    </Layout>
  );
}
